<template lang="pug">
  div.view-z.flex-row.align-items-center
    div.container
      div.row.justify-content-center
        div.col-md-6
          b-card.shadow-lg.rounded.theme-glass
            div.p-4
              div.d-flex.flex-row.align-items-baseline
                h1 {{ $t("message.app.name") }}
                p.flex-fill.text-right {{ $t("message.login") }}
              b-form.form-signin(@submit.stop.prevent="login" novalidate :disabled="!submission.success")
                b-input-group
                  b-input-group-text(slot="prepend")
                    i.icon-user
                  DebounceInput(
                    required
                    autofocus
                    type="text"
                    v-model.trim.lazy="$v.username.$model"
                    :placeholder='$t("ui.username")'
                    :disabled="loading"
                    :maxLength="$v.username.$params.maxLength.max"
                    :dirty="$v.username.$dirty"
                    :error="$v.username.$error"
                    )
                ValidateResult(:value="$v.username" :name="$t('ui.username')")
                b-input-group
                  b-input-group-text(slot="prepend")
                    i.icon-lock
                  DebounceInput(
                    required
                    autocomplete="section-red current-password"
                    type="password"
                    v-model.trim.lazy="$v.password.$model"
                    :placeholder='$t("ui.password")'
                    :disabled="loading"
                    :maxLength="$v.password.$params.maxLength.max"
                    :dirty="$v.password.$dirty"
                    :error="$v.password.$error"
                    )
                ValidateResult(:value="$v.password" :name="$t('ui.password')")
                div.row
                  div.col
                    b-alert.text-center.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
                div.row
                  div.col.text-right.mt-2
                    SubmitButton.btn-login(icon="fa fa-sign-in-alt" :text="$t('ui.login')" variant="secondary" size="lg" :loading="loading" isModal=false)
                div.row
                  div.col
                    small(style="color: rgba(255,255,255,.5);") {{ app.title }} v{{ app.version }}
</template>

<script>
import config from "@/config";
import { required, minLength, maxLength, alphaNum } from "vuelidate/lib/validators";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  data: function() {
    return {
      username: "",
      password: "",
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      redirect: "/monitor/status"
    };
  },
  validations: {
    username: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(20),
      alphaNum
    },
    password: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(20)
    }
  },
  computed: {
    app() {
      return {
        title: config.appTitle,
        version: config.appVersion
      };
    }
  },
  created() {
  },
  mounted: function() {
    const url = this.$route.query.redirect;
    if (url) {
      this.redirect = url;
    }
  },
  methods: {
    reset: function() {
      this.$v.$reset();
      this.submission.success = true;
      this.submission.status = "";
    },
    login: function() {
      this.reset();
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let username = this.username;
        let password = this.password;
        this.loading = true;
        this.$store
          .dispatch("user/login", { username, password })
          .then(response => {
            this.loading = false;
            // console.log(response)
            // console.log(this.$store.getters.accessRoles)
            this.submission.success = response.success;
            this.submission.status = response.status;
            // if (this.submission.success == true) {
            //   this.$router.push(this.redirect);
            // } else {
            //   this.loading = false;
            //   this.$router.push("/monitor/status");
            // }

            if (this.submission.success == true) {
              this.$router.push(response.redirect);
            }
          })
          .catch(response => {
            console.log(response)
            this.loading = false;
            this.submission.success = response.success;
            // this.submission.status =  response.status;
            this.submission.status = this.$t("error." + response.status);
            // this.submission.status = this.$t("error." + response.status) + (response.status == 'notWhitelistedIp' ? ' ' + this.$t("ui.your_ip") + response.ip : '') ;
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
h1 {
  color: #ffffff;
}

p {
  color: rgba(255, 255, 255, 0.5);
}

.card {
  margin-bottom: 0 !important;
  // background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

// .btn-login,
// .btn-login:hover {
//   border: 1px solid rgba(0, 0, 0, 0.75);
//   background: #f29941;
//   background: -moz-linear-gradient(top, #f29941 0%, #e8455d 100%);
//   background: -webkit-linear-gradient(top, #f29941 0%, #e8455d 100%);
//   background: linear-gradient(to bottom, #f29941 0%, #e8455d 100%);
//   color: #ffffff;
//   box-shadow: 0 0 16px rgba(255, 255, 255, 0.25);
// }

.input-group-text {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: white;
}

input {
  background: rgba(255, 255, 255, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: white;
}

input:focus {
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
}

.was-validated .form-control:valid,
.form-control.is-valid {
  border-color: rgba(0, 255, 255, 0.5);
  padding-right: 1.875rem;
  background-repeat: no-repeat;
  background-position: center right calc(1.875rem / 4);
  background-size: calc(1.875rem / 2) calc(1.875rem / 2);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2300ffff' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
}

input.is-valid {
  border: 1px solid rgba(0, 255, 255, 0.5);
}

input.is-invalid {
  border: 1px solid rgba(255, 0, 0, 0.5);
}
</style>
